import { AdvisingAbnormalItemFileBase64Bean } from './advising-abnormal-item-file-base64-bean';
import { AdvisingAbnormalOperationUserBean } from './advising-abnormal-operation-user-bean';
export class AdvisingAbnormalCreateAbnormalItemRequest extends AdvisingAbnormalOperationUserBean {
  adNo: string;
  abnormalCaseCnt: number | null;
  waitingReference: string | null;
  waitingReferenceDesc: string | null;
  relatedDetailSeqNos: number[] | null;
  relatedDetailExternLineNos: (string | null)[];
  relatedDetailSkus: (string | null)[];
  newFiles: AdvisingAbnormalItemFileBase64Bean[] | null;

  constructor() {
    super();
    this.adNo = "";
    this.abnormalCaseCnt = null;
    this.waitingReference = null;
    this.waitingReferenceDesc = null;
    this.relatedDetailSeqNos = [];
    this.relatedDetailExternLineNos = [];
    this.relatedDetailSkus = [];
    this.newFiles = null;
  }
}
